export default __webpack_public_path__ + "static/media/i20.f0e70077.jpg";